import React, { useState } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import GridTemplateConfigurationController from '../grid-template-config.controller';
import { TemplateSFObjectStore } from '../../../../store/models/template-object.model';
import { observer } from 'mobx-react';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps { 
    selectedTemplateName: string;
    updateViewSourceComponentConfig: Function;
    fieldInfo: IFieldData;
}

const GridOrderType = (props: IProps) => {
    const templateConfigCtrl: GridTemplateConfigurationController = new GridTemplateConfigurationController();
    const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
    const [orderType, setOrderType] = useState(0);
    React.useEffect(() => {
        if (orderType) {
            props.updateViewSourceComponentConfig('orderType', orderType);
            templateConfigCtrl.updateFieldValue('orderBy', orderType, props.selectedTemplateName);
        }
    }, [orderType]);
    return (
        <div className="slds-form-element">
            <label className="slds-form-element__label slds-text-body_medium">{props.fieldInfo.name}</label>
            <div className="slds-form-element__control">
                <div className="slds-select_container">
                    <select className="slds-select" onChange={(e: any) => setOrderType(e.target.value)} value={viewSourceComponentConfig.orderType}>
                        <option value="">Please select</option>
                        {TemplateSFObjectStore.standardObjectFields.fields.map((fieldValue: any) => {
                            return (<option key={fieldValue.name} value={fieldValue.name}>{fieldValue.label} - {fieldValue.name}</option>);
                        })};
                    </select>
                </div>
            </div>
        </div>
    )
}

export const GridComponentOrderType = observer(GridOrderType);